/* © Facilogi. See COPYRIGHT file for full copyright & licensing details. */

import En from "./En";
import Fr from "./Fr";

export {
    En,
    Fr
};
